module.exports = __webpack_public_path__ + "img/软件产品ISO文控.676092f3.png";